import type { CSSProperties } from "react";

export const DEFAULT_BOARD_SWATCH = "#71717a";

interface RgbComponents {
  readonly r: number;
  readonly g: number;
  readonly b: number;
}

export function resolveHexAccentColor(
  color: string | null | undefined,
  fallback: string,
): string {
  if (!color?.trim()) return fallback;
  const trimmed: string = color.trim();
  if (/^#[0-9a-fA-F]{6}$/.test(trimmed)) return trimmed;
  return fallback;
}

export function resolveBoardSwatch(color: string | null | undefined): string {
  return resolveHexAccentColor(color, DEFAULT_BOARD_SWATCH);
}

function parseHexRgb(hex: string): RgbComponents | null {
  const m = /^#?([0-9a-fA-F]{6})$/.exec(hex.trim());
  const cap = m?.[1];
  if (!cap) return null;
  const n: number = Number.parseInt(cap, 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

/** CSS variables for board-colored badge (border, fill, text, plus hover variants). */
export function boardBadgeToneVars(swatch: string): CSSProperties {
  const rgb: RgbComponents | null = parseHexRgb(swatch);
  const r: number = rgb?.r ?? 113;
  const g: number = rgb?.g ?? 113;
  const b: number = rgb?.b ?? 122;
  return {
    ["--board-badge-border" as string]: `rgba(${r}, ${g}, ${b}, 0.16)`,
    ["--board-badge-bg" as string]: `rgba(${r}, ${g}, ${b}, 0.08)`,
    ["--board-badge-fg" as string]: `rgba(${r}, ${g}, ${b}, 0.88)`,
    ["--board-badge-border-hover" as string]: `rgba(${r}, ${g}, ${b}, 0.32)`,
    ["--board-badge-bg-hover" as string]: `rgba(${r}, ${g}, ${b}, 0.14)`,
    ["--board-badge-fg-hover" as string]: `rgba(${r}, ${g}, ${b}, 0.95)`,
  };
}
